import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { required, email, minLength2 } from '../../utils/validation';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import CommonFileUpload from '../file-upload-links/CommonFileUpload';
import {
  FILE_FORMAT_PDF_IMAGE,
  SIGNIN_URL,
  HELP_CENTER_PUBLIC_PROFILE_FCNR_PARAM
} from '../../utils/constants';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { r_maxLength } from '../../utils/validation/restrictions';
import OutlinedTextFields from '../material-textField';
import BoxDropdown from '../form-controls/outlinedDropdown';
import RenderTextArea from '../form-controls/RenderTextArea';
import { API_URL } from '../../utils/config';
import { disableReturn, compileTemplate, checkParamInURL } from '../../utils/library';
import { getContentSchemaFromContentFul } from '../../redux/actions/common/common-action';
import { Link } from 'react-router-dom';
import { CountryDropdown, InputBox, TextAreaField, TextWrapper, TicketSuccess } from './styles';
import { showMessage } from '../../redux/actions/common-message/message-action';
import { createZendeskTicketforPublicPage } from '../../redux/actions/help-center-action/help-center-actions';
import CommonButton from '../common-button/CommonButton';
import { BACK_ARROW_ICON, TICKET_SUCCESS_ICON } from '@Images';

const NEW_TICKET = 'NEW_TICKET';

const fieldcustom = {
  document_code: 'FIN',
  document_input_type: 'FILE',
  is_back_required: false,
  label: 'Attachment (if any)',
  show_upload_button: true,
  file_field_name: 'zendesk_attachment'
};
const CreateTicket = ({
  className,
  formValues,
  currentScreen,
  handleSubmit,
  disableLoader,
  activateLoader,
  createZendeskTicketforPublicPage,
  dispatch,
  csManagerId,
  ticketSubjectLine
}) => {
  const [successScreen, setSuccessScreen] = useState({ data: {}, show: false });
  const [loginIssueContent, setLoginIssueContent] = useState({});

  // Check if FCNR query param is present
  const isFcnr = checkParamInURL(HELP_CENTER_PUBLIC_PROFILE_FCNR_PARAM) === 'true';

  useEffect(() => {
    getIssueContent();
    // eslint-disable-next-line
  }, []);
  const getIssueContent = async () => {
    const loginIssueContentResponse = await getContentSchemaFromContentFul(
      'pageLoginTroubleshooting',
      'WEB_TROUBLESHOOT'
    );
    if (isEmpty(loginIssueContentResponse)) {
      await dispatch(
        showMessage({ text: ['Something went wrong, please try after sometime'], type: 'info' })
      );
    } else {
      setLoginIssueContent(loginIssueContentResponse);
    }
  };
  const createTicket = async (data) => {
    activateLoader();
    const result = get(
      await createZendeskTicketforPublicPage({
        ...data,
        subject: ticketSubjectLine,
        groupId: csManagerId,
        ...(isFcnr && { level_1: 'trouble_logging_in__fcnr_ticket' })
      }),
      'data.data',
      {}
    );
    if (!isEmpty(result)) {
      setSuccessScreen((prevState) => ({
        ...prevState,
        data: result,
        show: true
      }));
    }
    disableLoader();
  };
  const renderFields = (ticketDataFieldsJSON) => {
    return ticketDataFieldsJSON.map((item, index) => {
      const validate = [];
      if (item.required) {
        validate.push(required);
      }
      if (item.isEmailField) {
        validate.push(email);
      }
      if (!isFcnr && item.name === 'fcnrQueryType') {
        return null;
      }
      switch (item.type) {
        case 'text':
          return (
            <InputBox>
              <Field
                name={item.name}
                type="text"
                key={item.name}
                component={OutlinedTextFields}
                normalize={r_maxLength(item.maxLength || 50)}
                maxWidth={'100%'}
                validate={validate}
                placeholder={item.placeholder}
              />
            </InputBox>
          );
        case 'dropdown':
          return (
            <CountryDropdown>
              <Field
                bindToThisObject={formValues[item.name]}
                name={item.name}
                type="text"
                key={item.name}
                component={BoxDropdown}
                placeholder={item.label}
                selectOnClose={true}
                validate={validate}
                width={'100%'}
                className="theme-dropdown"
                staticValues={!isEmpty(item.staticValues) ? item.staticValues : ''}
                url={item.url ? `${API_URL}${item.url}` : ''}
              />
            </CountryDropdown>
          );
        case 'text-area':
          return (
            <TextAreaField>
              <div className="input-header">{item.label}</div>
              <Field
                name={item.name}
                type="text"
                key={item.name}
                rows={item.rows || 4}
                component={RenderTextArea}
                parentClass="text-area"
                validate={[...[minLength2], ...validate]}
                label={item.label}
                placeholder={item.placeholder}
              />
            </TextAreaField>
          );
        case 'file':
          return (
            <div>
              <CommonFileUpload
                currentScreen={currentScreen}
                formName={NEW_TICKET}
                validate={FILE_FORMAT_PDF_IMAGE}
                key={item.name}
                fieldscustom={{
                  ...fieldcustom,
                  ...{
                    label: item.label,
                    file_field_name: item.name,
                    is_mandatory: item.required || false
                  }
                }}
                showSampleImageFlag={false}
              />
            </div>
          );
        default:
          return null;
      }
    });
  };
  const ticketDataFields = get(loginIssueContent, 'supportingDocument.target.fields', {});
  const ticketDataFieldsHeader = get(ticketDataFields, 'header.value', '');
  const ticketDataFieldsJSON = get(ticketDataFields, 'fieldJson.value.fields', []);
  const ticketDataSubmitButtonText = get(
    ticketDataFields,
    'submitButton.target.fields.label.value',
    ''
  );
  const successHeading = get(loginIssueContent, 'loginSuccessHeading.value', '');
  const successDesc = get(loginIssueContent, 'loginSuccessDescription.value', '');
  const successButtonText = get(loginIssueContent, 'loginSuccessButtonText.value', '');
  const successSubHeading = get(loginIssueContent, 'loginSuccessSubHeader.value', '');
  return (
    <section id="auth_container_wrapper_scroll" className={`auth_container_wrapper ${className}`}>
      <div className="auth_container_form social_error_screen">
        {!successScreen.show && (
          <>
            {!isFcnr && (
              <Link to={SIGNIN_URL}>
                <img src={BACK_ARROW_ICON} alt="go-back" width="20px" height="15px" />
              </Link>
            )}
            <div>
              <form
                onSubmit={handleSubmit(createTicket)}
                className="common-form"
                encType="multipart/form-data"
                id="form-zendesk-ticket"
                onKeyUp={disableReturn}
                onKeyPress={disableReturn}
              >
                {ticketDataFieldsHeader && (
                  <TextWrapper>
                    <div className="top-header">{ticketDataFieldsHeader}</div>
                  </TextWrapper>
                )}
                {!isEmpty(ticketDataFieldsJSON) && renderFields(ticketDataFieldsJSON)}
                <CommonButton
                  text={ticketDataSubmitButtonText}
                  width={380}
                  height={50}
                  margin="70px 0 0"
                  id="submit"
                />
              </form>
            </div>
          </>
        )}
        {successScreen.show && (
          <TicketSuccess>
            <div>
              <img src={TICKET_SUCCESS_ICON} alt="success ticket" />
            </div>
            {successHeading && <div className="header">{successHeading}</div>}
            {successSubHeading && (
              <div className="sub-header">
                {compileTemplate(successSubHeading, {
                  ticket_id: successScreen?.data?.ticket?.id
                })}
              </div>
            )}
            {successDesc && <div>{successDesc}</div>}
            <Link to={SIGNIN_URL} className="link">
              {' '}
              {successButtonText && <strong>{successButtonText}</strong>}
            </Link>
          </TicketSuccess>
        )}
      </div>
    </section>
  );
};
const ReduxFormCreateTicket = reduxForm({ form: NEW_TICKET })(CreateTicket);
function mapStateToProps(reduxState) {
  const formValues = getFormValues(NEW_TICKET)(reduxState) || {};
  return { formValues };
}
CreateTicket.propTypes = {
  className: PropTypes.string,
  createZendeskTicketforPublicPage: PropTypes.func,
  handleSubmit: PropTypes.any,
  currentScreen: PropTypes.any,
  formValues: PropTypes.any,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  dispatch: PropTypes.func,
  csManagerId: PropTypes.number,
  ticketSubjectLine: PropTypes.string
};
export default connect(mapStateToProps, {
  createZendeskTicketforPublicPage,
  activateLoader,
  disableLoader
})(ReduxFormCreateTicket);
